import { ADMIN_SETTINGS } from "../helpers/api-path";
import httpClient from "./http.interceptor";


const getCompanyListAPI = async (formData) => {
    return await httpClient.get(ADMIN_SETTINGS, {
        params: {
            ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
            type: "COMPANY",
            ...formData
        }
    });
}

const getAdminUsersListAPI = async (formData) => {
    return await httpClient.get(ADMIN_SETTINGS, {
        params: {
            ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
            type: "USER",
            ...formData
        }
    });
}

export {
    getCompanyListAPI,
    getAdminUsersListAPI
}